<template>
  <Layout.Header :class="getHeaderClass">
    <div :class="[`${prefixCls}-left`, isSubPage ? '' : 'w-180px']">
      <AppLogo v-if="!isSubPage" :class="`${prefixCls}-logo pr-8px`" :showTitle="false" />
      <BasicArrow
        v-if="showBack && isSubPage"
        left
        class="px-10px"
        :size="26"
        @click="handleBack"
      />
      <slot name="headerLeft"></slot>
      <Divider v-if="showUserAndTime && isSubPage" vertical />
      <NowTime v-if="showUserAndTime" class="min-w-138px font-500 text-32px" />
    </div>

    <slot v-if="!isSubPage" name="headerCenter"></slot>

    <div :class="[`${prefixCls}-action`, isSubPage ? '' : 'w-180px']">
      <slot name="headerRight"></slot>

      <DevPanel v-if="globalStore.getDeveloperMode" :class="`${prefixCls}-action__item`" />
      <Notify v-if="getShowNotice" :class="`${prefixCls}-action__item notify-item`" />

      <AppLocalePicker
        v-if="!isSubPage && getShowLocalePicker"
        :reload="true"
        :showText="false"
        :class="`${prefixCls}-action__item`"
      />

      <Divider v-if="showUserAndTime" vertical />
      <UserDropDown
        v-if="!isSubPage || showUserAndTime"
        showStatus
        :showName="showUserAndTime"
        :open="false"
        @click="goToUserPage"
      />
    </div>
  </Layout.Header>
</template>
<script lang="ts" setup>
  import { useThrottleFn } from '@vueuse/core';
  import { Layout } from 'ant-design-vue';
  import { useRouter } from 'vue-router';
  import { Divider, NowTime } from '@mts-fe/components';
  import { AppLocalePicker, AppLogo } from '@mts/components/Application';
  import { BasicArrow } from '@mts/components/Basic';
  import { useHeaderSetting } from '@mts/hooks/setting/useHeaderSetting';
  import { useDesign } from '@mts/hooks/web/useDesign';
  import { useLocale } from '@mts/locales/useLocale';
  import { emitter } from '@mts/utils';
  import { DevPanel, Notify, UserDropDown } from '@/layouts/default/header/components';
  import { getGlobalStore } from '@/store';

  defineOptions({ name: 'PadHeader' });

  const props = withDefaults(
    defineProps<{
      fixed?: boolean;
      isSubPage?: boolean;
      showUserAndTime?: boolean;
      showBack?: boolean;
      backEmit?: string;
      /** 默认返回事件前，false取消执行 */
      beforeBackFn?: () => Promise<void | false>;
      /** @deprecated */
      backFn?: Function;
    }>(),
    { showBack: true },
  );
  const { prefixCls } = useDesign('layout-header');

  const { getShowNotice } = useHeaderSetting();

  const globalStore = getGlobalStore();
  const { getShowLocalePicker } = useLocale();
  const getHeaderClass = [prefixCls, props.fixed ? `${prefixCls}--fixed` : ''];

  const router = useRouter();
  const handleBack = useThrottleFn(
    async () => {
      if (props.beforeBackFn) {
        const res = await props.beforeBackFn();
        if (typeof res === 'boolean' && !res) return;
      }
      if (props.backFn) return props.backFn();
      if (props.backEmit) emitter.emit('backEmit:' + props.backEmit);

      return router.back();
    },
    300,
    false,
  );
  const goToUserPage = () => router.push('/personal/page');
</script>

<style lang="less">
  @import url('@/layouts/default/header/index.less');
</style>
